import { Grid, Typography } from '@mui/material';
import ContentBox from '../../ContentBox/ContentBox';
import FollowUpButton from '../../FollowUpButton/FollowUpButton';
import React from 'react';

const TopicResult = ({ intl, text, onClear }) => {
  return (
    <Grid container spacing={2} wrap="nowrap" style={{ minHeight: '100%' }} sx={{ flexDirection: 'column' }}>
      <Grid>
        <ContentBox text={text} />
      </Grid>
      {text && (
        <Grid>
          <Grid container spacing={1}>
            <Grid>
              <FollowUpButton onClick={onClear}>
                {intl.formatMessage({ id: 'chat-gpt-follow-up-clear' })}
              </FollowUpButton>
            </Grid>
          </Grid>
        </Grid>
      )}
    </Grid>
  );
};

export default TopicResult;
